import { IBaseRequestOptions } from './types';

import type { AxiosInstance, AxiosRequestConfig } from 'axios';

const importAxios = () => import('axios').then((axios) => axios.default);

export default class BaseRequest {
  private _axios: undefined | ReturnType<typeof importAxios>;
  private _request: undefined | Promise<AxiosInstance>;
  protected options: IBaseRequestOptions;

  protected get axios() {
    if (!this._axios) {
      this._axios = importAxios();
    }

    return this._axios;
  }

  protected get request() {
    if (!this._request) {
      this._request = this.axios.then((axios) => {
        const request = axios.create({
          baseURL: this.options.baseUrl,
          timeout: this.options.timeout ?? 30000,
        });

        request.interceptors.request.use(async (config) => {
          const recaptchaToken = await this.options.getRecaptchaToken();
          config.headers['X-Recaptcha-Token'] = recaptchaToken;
          return config;
        });

        return request;
      });
    }

    return this._request;
  }

  protected async get<D = any>(url: string, config?: AxiosRequestConfig<D>) {
    const req = await this.request;

    return req.get(url, config);
  }

  protected async post<D = any>(url: string, data: D, config?: AxiosRequestConfig<D>) {
    const req = await this.request;

    return req.post(url, data, config);
  }

  constructor(options: IBaseRequestOptions) {
    this.options = options;
  }
}
